import React, { createContext, useContext, useEffect, useState } from "react";

const API = process.env.REACT_APP_API_URL || "";

// undefined = chargement en cours, null = non connecté, objet = utilisateur connecté
const AuthContext = createContext({ user: undefined });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    fetch(`${API}/api/me`, { credentials: "include" })
      .then((res) => res.json())
      .then((data) => {
        setUser(data.user ?? null);
        // Mot de passe "jeton" pas encore remplacé : on force le passage par
        // le formulaire dédié avant toute autre page (rechargement,
        // navigation directe par URL, nouvel onglet...).
        if (data.user?.mustChangePassword && window.location.pathname !== "/changer-mot-de-passe") {
          window.location.href = "/changer-mot-de-passe";
        }
      })
      .catch(() => setUser(null));
  }, []);

  return <AuthContext.Provider value={{ user }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
